/* eslint-disable react/jsx-sort-props */

/**
 * DO NOT MODIFY THIS ICON DIRECTLY.
 *
 * THIS ICON WAS AUTOMATICALLY GENERATED.
 * SVG RETRIEVED FROM SPRING FOUNDATIONS FIGMA FILE.
 * @see https://www.figma.com/design/kcg95u086DD7Sa9or8Bwpq/%F0%9F%8C%B1--Foundations---Spring-2.0?node-id=24-2&p=f&t=75lUXy0FPOr0htKP-0
 */
import React from 'react';

import {Icon as BaseIcon, type BaseIconProps} from './Icon/Icon';
import {IconComponent} from './types';

export const AddPanelFormInput64Icon = React.forwardRef<
  HTMLDivElement,
  BaseIconProps
>(({size = 64, ...props}, ref) => {
  return (
    <BaseIcon {...props} size={size} ref={ref}>
      <svg
        data-wf-icon="AddPanelFormInput64Icon"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <path
            opacity="0.1"
            d="M8 25C8 22.7909 9.79086 21 12 21H52C54.2091 21 56 22.7909 56 25V38C56 40.2091 54.2091 42 52 42H12C9.79086 42 8 40.2091 8 38V25Z"
            fill="currentColor"
          />
          <g>
            <path d="M13 26L13 37H14L14 26H13Z" fill="currentColor" />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M8 25C8 22.7909 9.79086 21 12 21H52C54.2091 21 56 22.7909 56 25V38C56 40.2091 54.2091 42 52 42H12C9.79086 42 8 40.2091 8 38V25ZM12 22H52C53.6569 22 55 23.3431 55 25V38C55 39.6569 53.6569 41 52 41H12C10.3431 41 9 39.6569 9 38V25C9 23.3431 10.3431 22 12 22Z"
              fill="currentColor"
            />
          </g>
        </g>
      </svg>
    </BaseIcon>
  );
}) as IconComponent;

AddPanelFormInput64Icon.tags = ['form', 'input', 'field', 'add', 'panel'];

AddPanelFormInput64Icon.category = '64x64 (Add panel)';

AddPanelFormInput64Icon.iconSize = 64;
